import { Component, Inject, Input } from '@angular/core';
import { MarginalDirective } from '../../../marginals/components/marginal';
import { IBackgroundImageStyle } from '../../../models/interfaces/i-background-image-style.interface';
import { IWindowSnare } from '../../../models/interfaces/i-window-snare.interface';
import { Logo } from '../../../models/themes/logo.model';
import { WINDOW } from '../../../shared-providers/window.providers';
import { SessionStorageService } from '../../../shared-services/services/session-storage.service';
import { ThemeService } from '../../../shared-services/services/theme.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-login-header',
    templateUrl: './login-header.component.html',
    styleUrls: ['./login-header.component.scss'],
    standalone: false
})
export class LoginHeaderComponent extends MarginalDirective {
    @Input() goBackToLogin = false;

    public loginLogo: string;

    public logo: Logo;

    constructor(
        private router: Router,
        public sessionStorageService: SessionStorageService,
        public themeService: ThemeService,
        @Inject(WINDOW) window: IWindowSnare
    ) {
        super(themeService, sessionStorageService, window);

    }

    public themeAvailable(): void {
        this.logo = this.theme.themePrimaryLogo;
    }

    public navigateToLogin(): void {
        if (this.goBackToLogin) {
            this.router.navigate(['login']);
        }
    }

    public getSubscriptionLogo(): IBackgroundImageStyle {
        if (this.theme) {
            return {
                'background-image': `url(${encodeURI(this.theme.themeSecondaryLogo.url)})`
            };
        } else {
            return {
                'background-image': `url(${encodeURI('./assets/imgs/login/logo.png')})`
             };
        }
    }
}
